import ForgotPasswordCode from '../components/auth/forgot-password-code';

const ForgotPasswordCodePage = (): JSX.Element => <ForgotPasswordCode />;

export default ForgotPasswordCodePage;
